import { path } from 'ramda'
import { createSelector } from 'reselect'
import { NestedListInterface, StateInterface } from '../types/states'

const selectListsDomain = (state: StateInterface) => state.lists
const selectedNestedLists = createSelector(
  selectListsDomain,
  (lists) => lists.nestedLists
)

const selectNestedList = (listName: string) =>
  createSelector(
    selectedNestedLists,
    (nestedLists) => nestedLists[listName] as NestedListInterface
  )

const selectNestedListIdByName = (listName: string) =>
  createSelector(selectedNestedLists, (nestedLists) =>
    path([`${listName}`, `id`], nestedLists)
  )

export { selectListsDomain, selectNestedList, selectNestedListIdByName }
